var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 12 12",
    enableBackground: "new 0 0 12 12",
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    fill: "#1D1D1B",
    height: 1,
    width: 11,
    x: 0.5,
    y: 5.5
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#1D1D1B",
    height: 1,
    width: 11,
    x: 0.5,
    y: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#1D1D1B",
    height: 1,
    width: 11,
    x: 0.5,
    y: 8.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpen);
export default __webpack_public_path__ + "static/media/open.a0250e0ba0f8de521f2f2a550cbb6502.svg";
export { ForwardRef as ReactComponent };